import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue } from "react";
import { getEffectTarget } from "@lilib/utils";
import useSafeState from "./useSafeState";
import useResizeObserver from "./useResizeObserver";
function useElementSize(target) {
  var _useSafeState = useSafeState(function () {
      var element = getEffectTarget(target);
      if (element) {
        var rect = element.getBoundingClientRect();
        return {
          width: rect.width,
          height: rect.height
        };
      } else {
        return {
          width: undefined,
          height: undefined
        };
      }
    }),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    _useSafeState2$ = _useSafeState2[0],
    width = _useSafeState2$.width,
    height = _useSafeState2$.height,
    setSize = _useSafeState2[1];
  useResizeObserver(target, function (entries) {
    if (entries[0]) {
      var rect = entries[0].target.getBoundingClientRect();
      if (rect.width !== width || rect.height !== height) {
        setSize({
          width: rect.width,
          height: rect.height
        });
      }
    }
  });
  useDebugValue({
    width: width,
    height: height
  });
  return {
    width: width,
    height: height
  };
}
export default useElementSize;